import { MessageBodySchema, type MessageBody } from '@foyer/shared';

/**
 * Encodes/decodes the `alg: "plain"` payload (ADR-0004). Manual base64 via
 * TextEncoder/TextDecoder rather than any newer typed-array base64 method —
 * those only landed in very recent Chrome, and the device floor (ADR-0002)
 * doesn't guarantee that yet.
 */

export function encodePlainPayload(body: MessageBody): string {
  const bytes = new TextEncoder().encode(JSON.stringify(body));
  let binary = '';
  const chunk = 0x8000; // avoid a huge call stack via spread/apply on one big array
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

export function decodePlainPayload(payload: string): MessageBody {
  const binary = atob(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const json = new TextDecoder().decode(bytes);
  return MessageBodySchema.parse(JSON.parse(json));
}
